import Modal from 'antd/es/modal';
import { Button } from 'antd';
import { useUnit } from 'effector-react';
import {
  $language,
  confirmUserAgreementEv,
} from '../../models/authModel/index.js';
import LanguageSelector from '../LanguageSelector/LanguageSelector.jsx';

export default function UserAgreementModal() {
  const agree = useUnit(confirmUserAgreementEv);
  const lang = useUnit($language);

  return (
    <Modal
      open
      destroyOnClose
      closeIcon={null}
      footer={null}
      closable={false}
      width={'70dvw'}
    >
      <LanguageSelector />
      {lang === 'kz' ? <AgreementKz /> : <AgreementRu />}
      <Button onClick={() => agree()} type={'primary'}>
        {lang === 'kz' ? 'Келісемін' : 'Согласен'}
      </Button>
    </Modal>
  );
}

function AgreementRu() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        maxHeight: '60dvh',
        overflow: 'auto',
        marginBottom: 32,
      }}
    >
      <p>
        Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует
        условия использования веб-сайта и связанных с ним сервисов (далее —
        «Сервис»). Регистрируясь в Сервисе, пользователь подтверждает, что
        ознакомился, понимает и принимает условия настоящего Соглашения.
      </p>

      <h3>1. Общие положения</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span>
          1.1. Использование Сервиса допускается только после принятия
          настоящего Соглашения.
        </span>
        <span>
          1.2. Сервис предоставляется для получения информации, взаимодействия с
          функционалом платформы и использования доступных инструментов.
        </span>
        <span>
          1.3. Администрация оставляет за собой право изменять Соглашение без
          дополнительного уведомления. Актуальная версия всегда доступна
          пользователю при регистрации или авторизации.
        </span>
      </div>

      <h3>2. Регистрация и учетная запись</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span>
          2.1. Пользователь обязуется предоставлять достоверные данные при
          регистрации.
        </span>
        <span>
          2.2. Пользователь несёт ответственность за сохранность данных своей
          учетной записи.
        </span>
        <span>
          2.3. Администрация не несёт ответственности за действия третьих лиц,
          получивших доступ к учетной записи пользователя по его вине.
        </span>
      </div>

      <h3>3. Права и обязанности пользователей</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <strong>Пользователь имеет право:</strong>{' '}
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>использовать функционал Сервиса в установленном порядке;</li>
          <li>получать информацию и материалы, представленные в Сервисе.</li>
        </ul>
        <strong>Пользователь обязуется:</strong>
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>соблюдать требования законодательства;</li>
          <li>
            не предпринимать действий, направленных на нарушение работы Сервиса;
          </li>
          <li>
            не размещать и не передавать вредоносные данные, незаконный или
            запрещённый контент.
          </li>
        </ul>
      </div>

      <h3>4. Права и обязанности администрации</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <strong>Администрация вправе:</strong>
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>
            изменять, обновлять или ограничивать доступ к сервису без объяснения
            причин;
          </li>
          <li>
            блокировать учетные записи пользователей, нарушающих Соглашение или
            нормы законодательства;
          </li>
          <li>
            проводить техническое обслуживание, которое может временно
            ограничивать доступ к Сервису.
          </li>
        </ul>
        <strong>Администрация обязуется:</strong>
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>
            обеспечивать защиту персональных данных в соответствии с
            законодательством;
          </li>
          <li>
            использовать предоставленные данные только в целях функционирования
            Сервиса.
          </li>
        </ul>
      </div>

      <h3>5. Персональные данные</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span>
          5.1. Пользователь даёт согласие на обработку своих персональных
          данных, включающих регистрационные данные и сведения, необходимые для
          функционирования Сервиса.
        </span>
        <span>
          5.2. Персональные данные обрабатываются в строго определённых целях —
          для идентификации, предоставления доступа, аналитики и повышения
          качества сервиса.
        </span>
        <span>
          5.3. Пользователь вправе запросить удаление своих данных, если иное не
          предусмотрено законом.
        </span>
      </div>

      <h3>6. Ограничение ответственности</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span>
          6.1. Сервис предоставляется «как есть» без гарантий бесперебойности и
          абсолютной точности данных.
        </span>
        <span>
          6.2. Администрация не несёт ответственности за возможные убытки,
          возникшие вследствие использования или невозможности использования
          Сервиса.
        </span>
        <span>
          6.3. Пользователь самостоятельно несёт ответственность за все
          действия, совершённые в Сервисе под его учетной записью.
        </span>
      </div>

      <h3>7. Заключительные положения</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span>
          7.1. Принятие Соглашения является обязательным условием регистрации и
          использования Сервиса.
        </span>
        <span>
          7.2. Продолжая использование Сервиса, пользователь подтверждает своё
          согласие с условиями.
        </span>
        <span>
          7.3. Вопросы и предложения по работе Сервиса могут быть направлены
          через форму обратной связи.
        </span>
      </div>
    </div>
  );
}

function AgreementKz() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        maxHeight: '60dvh',
        overflow: 'auto',
        marginBottom: 32,
      }}
    >
      <p>
        Осы Пайдаланушы келісімі (бұдан әрі – «Келісім») веб-сайт пен оған
        қатысты сервистерді (бұдан әрі – «Сервис») пайдалану шарттарын реттейді.
        Сервиске тіркелу арқылы пайдаланушы осы Келісімнің шарттарымен танысып,
        оларды толық көлемде қабылдағанын растайды.
      </p>

      <h3>1. Жалпы ережелер</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span>
          1.1. Сервисті пайдалану осы Келісімді қабылдағаннан кейін ғана мүмкін.
        </span>
        <span>
          1.2. Сервис ақпарат алу, платформа функционалын пайдалану және
          ұсынылған құралдарға қол жеткізу үшін беріледі.
        </span>
        <span>
          1.3. Әкімшілік Келісімнің мәтінін алдын ала хабарламай өзгертуге
          құқылы. Актуалды нұсқа пайдаланушыға тіркелу немесе авторизациякезінде
          ұсынылады.
        </span>
      </div>

      <h3>2. Тіркелу және есептік жазба</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span>
          2.1. Пайдаланушы тіркелу кезінде дұрыс және өзекті деректерді
          көрсетуге міндетті.
        </span>
        <span>
          2.2. Пайдаланушы өзінің есептік жазбасының құпия деректерін сақтау
          үшін жауап береді.
        </span>
        <span>
          2.3. Пайдаланушының өз кінәсінен есептік жазбасына үшінші тұлғалардың
          қол жеткізуіне Әкімшілік жауап бермейді.
        </span>
      </div>

      <h3>3. Пайдаланушылардың құқықтары мен міндеттері</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <strong>Пайдаланушының құқықтары:</strong>{' '}
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>Сервистің функционалын белгіленген тәртіпте пайдалану;</li>
          <li>Сервисте ұсынылған ақпарат пен материалдарды алу.</li>
        </ul>
        <strong>Пайдаланушының міндеттері:</strong>{' '}
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>Қазақстан Республикасының заңнамасын сақтау;</li>
          <li>Сервис жұмысына кедергі келтіретін әрекеттер жасамау;</li>
          <li>Вирус, зиянды файлдар немесе заңсыз контент таратпау.</li>
        </ul>
      </div>

      <h3>4. Әкімшіліктің құқықтары мен міндеттері</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <strong>Әкімшілік құқылы:</strong>
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>Сервисті өзгертуге, жаңартуға немесе шектеуге;</li>
          <li>
            Келісімді немесе заңнаманы бұзған пайдаланушылардың есептік жазбасын
            бұғаттауға;
          </li>
          <li>
            Техникалық жұмыстар жүргізуге (уақытша шектеулер болуы мүмкін).
          </li>
        </ul>
        <strong>Әкімшілік міндетті:</strong>
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>Жеке деректердің қорғалуын қамтамасыз ету;</li>
          <li>
            Пайдаланушы деректерін Сервистің жұмыс істеуіне қажетті мақсаттарда
            ғана пайдалану.
          </li>
        </ul>
      </div>

      <h3>5. Жеке деректерді өңдеу</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span>
          5.1. Пайдаланушы өзінің жеке деректерін өңдеуге келісім береді
          (тіркелу деректері, идентификация үшін қажетті ақпарат).
        </span>
        <span>
          5.2. Деректер Сервиске қол жеткізу, жұмыс сапасын арттыру және
          аналитика мақсатында өңделеді.
        </span>
        <span>
          5.3. Пайдаланушы деректерді жоюға өтініш бере алады, егер бұл заңмен
          шектелмесе.
        </span>
      </div>

      <h3>6. Жауапкершілікті шектеу</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span>
          6.1. Сервис «қалай бар – солай» күйінде ұсынылады және оның үздіксіз
          жұмысына немесе деректердің толық дәлдігіне кепілдік берілмейді.
        </span>
        <span>
          6.2. Сервисті пайдалану немесе пайдалану мүмкін еместігі салдарынан
          туындаған мүмкін залалдар үшін Әкімшілік жауап бермейді.
        </span>
        <span>
          6.3. Есептік жазба арқылы жасалған барлық әрекеттер үшін пайдаланушы
          өзі жауапты.
        </span>
      </div>

      <h3>7. Қорытынды ережелер</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span>
          7.1. Келісімді қабылдау – Сервисті пайдалану үшін міндетті шарт.
        </span>
        <span>
          7.2. Пайдаланушы Сервиске қол жеткізуін жалғастыру арқылы Келісім
          шарттарымен толық келісетінін растайды.
        </span>
        <span>
          7.3. Сервиске қатысты ұсыныстар мен сұрақтар кері байланыс формасы
          арқылы қабылданады.
        </span>
      </div>
    </div>
  );
}
